/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type { CookieDisclaimer } from '../../services/types';

export const LINK_TEXT = '{privacyStatementLink}';
export const COOKIE_NAME = 'gdpr-cookie-notification';
export const COOKIE_VALUE = 'closed';
export const COOKIE_EXPIRY_DAYS = 180;

export const defaultCookieDisclaimer: CookieDisclaimer = {
  text: `We use cookies to give you a better experience on AirAsia.com. By continuing to use our website, you are agreeing to the use of cookies as set out in our ${LINK_TEXT}`,
  privacyStatementLink:
    'https://www.airasia.com/aa/about-us/en/gb/privacy-statement.html',
  privacyStatementText: 'Privacy Statment',
};
